module.exports = __webpack_public_path__ + "img/G_Art_Claw_R_2_3_2.a980b89c.png";